import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Spring/MultiplicationAndDivisionB/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MultiplicationAndDivisionB',
  field: 'Number',
  weeks: [1, 3],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/1FactorPairs" */ './1FactorPairs'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/2UseFactorPairs" */ './2UseFactorPairs'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/3MultiplyBy10" */ './3MultiplyBy10'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/4MultiplyBy100" */ './4MultiplyBy100'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/5DivideBy10" */ './5DivideBy10'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/6DivideBy100" */ './6DivideBy100'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/7RelatedFactsMultiplicationAndDivision" */ './7RelatedFactsMultiplicationAndDivision'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/8InformalWrittenMethodsForMultiplication" */ './8InformalWrittenMethodsForMultiplication'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/9MultiplyA2DigitNumberByA1DigitNumber" */ './9MultiplyA2DigitNumberByA1DigitNumber'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/10MultiplyA3DigitNumberByA1DigitNumber" */ './10MultiplyA3DigitNumberByA1DigitNumber'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/11DivideA2DigitNumberByA1DigitNumber1" */ './11DivideA2DigitNumberByA1DigitNumber1'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/12DivideA2DigitNumberByA1DigitNumber2" */ './12DivideA2DigitNumberByA1DigitNumber2'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/13DivideA3DigitNumberByA1DigitNumber" */ './13DivideA3DigitNumberByA1DigitNumber'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/14CorrespondenceProblems" */ './14CorrespondenceProblems'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/MultiplicationAndDivisionB/15EfficientMultiplication" */ './15EfficientMultiplication'
        )
    })
  ]
});
export default Block;
